module.exports = __webpack_public_path__ + "src/assets/img/m45.e739eb47.svg";